import React from 'react';
import { AGREEXA_APP_URL } from '../lib/links';
import { Hammer, Github, Twitter, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-gray-300 py-16 border-t border-white/10" data-id="element-93">
      <div className="max-w-7xl mx-auto px-6" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-95">
          <div className="lg:col-span-2" data-id="element-96">
            <div className="flex items-center gap-2 mb-6" data-id="element-97">
              <div className="w-8 h-8 rounded-lg bg-orange-500 flex items-center justify-center text-white" data-id="element-98">
                <Hammer size={18} data-id="element-99" />
              </div>
              <span className="text-2xl font-bold text-white tracking-tight" data-id="element-100">
                Agreexa
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-101">
              The world's most modern platform for people who love building,
              creating, repairing, improving and inventing.
            </p>
            <div className="flex gap-4" data-id="element-102">
              <a href={AGREEXA_APP_URL} aria-label="Twitter" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all" data-id="element-103">
                <Twitter size={18} data-id="element-104" />
              </a>
              <a href={AGREEXA_APP_URL} aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all" data-id="element-105">
                <Instagram size={18} data-id="element-106" />
              </a>
              <a href={AGREEXA_APP_URL} aria-label="YouTube" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all" data-id="element-107">
                <Youtube size={18} data-id="element-108" />
              </a>
              <a href={AGREEXA_APP_URL} aria-label="GitHub" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all" data-id="element-109">
                <Github size={18} data-id="element-110" />
              </a>
            </div>
          </div>

          <div data-id="element-111">
            <h4 className="text-white font-semibold mb-6" data-id="element-112">Platform</h4>
            <ul className="space-y-4 text-sm" data-id="element-113">
              <li data-id="element-114">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-115">
                  Explore Projects
                </a>
              </li>
              <li data-id="element-116">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-117">
                  AI Generator
                </a>
              </li>
              <li data-id="element-118">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-119">
                  Maker Tools
                </a>
              </li>
              <li data-id="element-120">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-121">
                  Marketplace
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-122">
            <h4 className="text-white font-semibold mb-6" data-id="element-123">Community</h4>
            <ul className="space-y-4 text-sm" data-id="element-124">
              <li data-id="element-125">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-126">
                  Forums
                </a>
              </li>
              <li data-id="element-127">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-128">
                  Top Creators
                </a>
              </li>
              <li data-id="element-129">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-130">
                  Events
                </a>
              </li>
              <li data-id="element-131">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-132">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-133">
            <h4 className="text-white font-semibold mb-6" data-id="element-134">Company</h4>
            <ul className="space-y-4 text-sm" data-id="element-135">
              <li data-id="element-136">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-137">
                  About Us
                </a>
              </li>
              <li data-id="element-138">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-139">
                  Careers
                </a>
              </li>
              <li data-id="element-140">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-141">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-142">
                <a href={AGREEXA_APP_URL} className="hover:text-orange-400 transition-colors" data-id="element-143">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-144">
          <p data-id="element-145">© {new Date().getFullYear()} Agreexa. All rights reserved.</p>
          <p className="flex items-center gap-1" data-id="element-146">
            Build Better. Create Smarter. Live Independently.
          </p>
        </div>
      </div>
    </footer>;
}